import "./coin_management.scss";

let coinManagementComponent = {
  restrict: "E",
  bindings: {},
};

export default coinManagementComponent;



// WEBPACK FOOTER //
// ./client/app/components/coin_management/coin_management.component.js